var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadenaSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34.251mm",
    height: "32.766mm",
    viewBox: "0 0 34.251 32.766",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "#fff",
    "data-name": "Rectangle 24148"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124.66 -84.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KDA",
    transform: "matrix(.26458 0 0 .26458 112.58 71.686)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4a9079"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m175.09 172.54h-45.118l-0.03-0.022-0.355-0.272-55.913-43.382 22.885-18.244 78.154 61.626z",
    "data-name": "Path 143799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.09 48.7h-45.118l-0.03 0.022-0.355 0.273-55.913 43.379 22.885 18.245 78.154-61.626z",
    "data-name": "Path 143800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.684 113.37v15.5l7e-3 43.374v0.295l-0.03-0.022-0.348-0.273-27.213-21.375-0.067-0.052-0.392-0.3v-79.792l0.392-0.3 0.067-0.052 27.213-21.379 0.348-0.273 0.03-0.022v0.295l-7e-3 43.374v21z",
    "data-name": "Path 143801"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadenaSimple);
export default __webpack_public_path__ + "static/media/kadena_simple.0c9e03e6a98ceea098c5721a4ffe876f.svg";
export { ForwardRef as ReactComponent };